// import { DEFAULT_CLIENT_SOURCE } from '../Constants/common';
import defaultColors from './defaultColors'
import semaColors from './semaColors'
import anayaColors from './anayaColors'
import constants from '../constants'
import { fonts } from './fonts'

export const THEME_COLORS = {
  default: defaultColors,
  'anaya-care': anayaColors,
  [constants.CARE_PROGRAM_TYPE.ANAYA]: anayaColors,
  [constants.CARE_PROGRAM_TYPE.GLP]: semaColors,
}

export const THEME_FONTS = {
  default: fonts.default,
  'anaya-care': fonts['anaya-care'],
  [constants.CARE_PROGRAM_TYPE.ANAYA]: fonts['anaya-care'],
  [constants.CARE_PROGRAM_TYPE.GLP]: fonts[constants.CARE_PROGRAM_TYPE.GLP],
}
